import AccountNavigation from '@/features/account-navigation/AccountNavigation';
import { AccountNavigationContextType } from '@/features/account-navigation/AccountNavigation.hooks';

const AccountNavigationPopover = (props: AccountNavigationContextType) => {
  return (
    <div className="bg-bg_neutral border-border_bold p-xl w-[340px] rounded-md border drop-shadow-lg">
      <AccountNavigation {...props} />
    </div>
  );
};

export default AccountNavigationPopover;
